<div class="flex items-center gap-2">
    {{ emailSupport() }}
    <p-button [text]="true" icon="pi pi-copy" (click)="copyEmail()" severity="secondary" />
</div>
